import { Location } from "@/custom-types/Location";

/**
 * This function loosely asserts that some value looks like it could be a
 * Location. Our current Location object is extremely permissive, so this
 * type predicate function only checks that the value is an object with
 * a subset of known properties being present in some form.
 *
 * Over time this validation should become more strict as we make the
 * Location type itself has fewer optional properties.
 *
 * See: https://www.typescriptlang.org/docs/handbook/2/narrowing.html#using-type-predicates
 */

export const isLocation = (location: unknown): location is Location => {
  if (location === null || typeof location !== "object") {
    return false;
  }

  return Boolean(
    "coordinates" in location &&
      location.coordinates !== null &&
      typeof location.coordinates === "object" &&
      ("lat" in location.coordinates || "latitude" in location.coordinates) &&
      ("lon" in location.coordinates ||
        "longitude" in location.coordinates ||
        "lng" in location.coordinates),
  );
};
